import { useConfigAPIFetcher } from './useConfigAPIFetcher'
import { useCallback } from 'react'

export function useIoTHubAddLocationIdFetcher() {
  const fetcher = useConfigAPIFetcher()

  return useCallback(
    ({ clientId, locationId }: { clientId: string; locationId: string }) => {
      return fetcher({
        plugin: 'iothub',
        method: 'addLocationId',
        data: { clientId, locationId },
      })
    },
    [fetcher],
  )
}
